import { DI } from '@microsoft/fast-foundation';
/**
 * Default AppConfig DI implementation.
 * @public
 */
export const defaultAppConfig = {
    /**
     * TODO: Assignment of context.
     */
    context: {
        env: 'development',
        domain: location.hostname,
        user: {},
        answers: {},
        featureFlags: {},
    },
    defaultElementRepeatOptions: {
        positioning: true,
    },
};
/**
 * AppConfig DI key.
 *
 * @internal
 * @privateRemarks
 * Marked as internal to stop api-extractor becoming confused cross-linking tokens with the same name.
 */
export const AppConfig = DI.createInterface((x) => x.instance(defaultAppConfig));
